import { render, staticRenderFns } from "./generalFuncBox.vue?vue&type=template&id=65e15fde&scoped=true&"
import script from "./generalFuncBox.vue?vue&type=script&lang=js&"
export * from "./generalFuncBox.vue?vue&type=script&lang=js&"
import style0 from "./generalFuncBox.vue?vue&type=style&index=0&id=65e15fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e15fde",
  null
  
)

export default component.exports